/**
 * @desc 根据洲（省）和城市编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseCityResponseDto>;
export function request(cityCode: string, stateCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCity/byStateAndCityCode/${stateCode}/${cityCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
